// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"5":"3a480efd","135":"d0544563","584":"b0ca25fd","655":"f0cb40a4"}[chunkId] + ".js";
};